import { computed, Component, inject, input, output, ChangeDetectionStrategy } from '@angular/core';

import { I18nService } from '@core/i18n-legacy';
import { LoginMethod, TeamMemberStatus } from '@core/tellent-types';
import { ButtonComponent, IconComponent } from '@core/user-interface-legacy';

import { getMemberStatusConfig, type MemberStatusConfig } from '../edit-member-status.config';

@Component({
  selector: 'tlc-edit-member-status-actions',
  imports: [ButtonComponent, IconComponent],
  templateUrl: './edit-member-status-actions.component.html',
  styleUrl: './edit-member-status-actions.component.less',
  changeDetection: ChangeDetectionStrategy.Eager,
  host: {
    '[class.has-no-action]': '!this.currentConfig().action',
  },
})
export class EditMemberStatusActionsComponent {
  private readonly i18n = inject(I18nService);

  public currentStatus = input.required<TeamMemberStatus>();
  public hasWorkEmail = input.required<boolean>();
  public hasPersonalEmail = input.required<boolean>();
  public orgHasGrowStandalone = input.required<boolean>();
  public loginMethod = input.required<LoginMethod>();
  public usersWithoutEmails = input.required<boolean | undefined>();
  public actionClicked = output<'preonboarding' | TeamMemberStatus>();

  protected currentConfig = computed<Partial<MemberStatusConfig>>(() =>
    getMemberStatusConfig(
      this.currentStatus(),
      {
        hasWorkEmail: this.hasWorkEmail(),
        hasPersonalEmail: this.hasPersonalEmail(),
        loginMethod: this.loginMethod(),
      },
      this.i18n,
      this.usersWithoutEmails(),
      this.orgHasGrowStandalone(),
    ),
  );

  protected isPreonboarding = computed(
    () =>
      this.usersWithoutEmails() &&
      this.currentStatus() === 'notInvited' &&
      !this.hasWorkEmail() &&
      this.hasPersonalEmail() &&
      !this.orgHasGrowStandalone(),
  );
}
